module.exports = __webpack_public_path__ + "static/media/menu.282b0185.svg";